<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14uM7DX/tc-custom/9781446361016.jpg?1728726136851" alt="This image is the cover for the book Pink Whisk Guide to Bread Making, The Pink Whisk Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pink Whisk Guide to Bread Making, The Pink Whisk Guide
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The Great British Bake Off</i></b><b> finalist shares delicious bread recipes that rise to every occasion—loaves of all shapes to suit all tastes.</b></p><p><b> </b>Ruth Clemens, finalist on <i>The Great British Bake Off</i>, shares her delicious bread recipes, fitting for all occasions. </p><p> Each of the thirty recipes shows you how to get confident with straightforward doughs, to progress to pre-ferments and experiment with further methods. </p><p> Along with clear step-by-step instructions, the recipes are crammed with tips and tricks to ensure that you’ll be turning out delicious homemade loaves in next to no time. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Clemens
      </h2>
      
      <p class="authorDescription body article"><P><B>Ruth Clemens</B> is a baker, cake decorator and very busy wife and mother. Completely self taught, Ruth's passion for baking and sugarcrafting shone through when she was a contestant on <I>The Great British Bake Off</I>. The Pink Whisk blog was born and the rest, as they say, is history! She is also the author of <I>The Pink Whisk Guide to Cake Making</I> and <I>Busy Girl's Guide to Cake Decorating</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fdc0a6f6